export function extractSectionId(element) {
    element = element.classList.contains('shopify-section') ? element : element.closest('.shopify-section');
    return element.id.replace('shopify-section-', '');
}
